module.exports = __webpack_public_path__ + "img/co2.89715b58.svg";